var React = require('react');

function M2ProLogoCollapsedComponent (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 17.0588V13.9426H28.4777V13.914C31.1356 12.7391 35.7744 10.7404 35.7744 6.58552C35.7744 3.30456 33.0196 0.5 29.1331 0.5C25.243 0.5 23.2549 3.15412 22.3845 5.55036L25.2645 6.6679C25.9092 4.66924 27.0591 3.45142 29.1618 3.45142C30.9994 3.45142 32.5218 4.80893 32.3642 6.61417C32.1671 8.93518 29.6597 10.6258 27.3564 11.8866C25.5905 12.8465 22.8573 14.2111 22.8573 14.2111V17.0588H36Z","fill":"#3216B5","key":0}),React.createElement("path",{"d":"M0 1.11963V17.0587H3.43881V5.09544L8.40001 17.0587H11.0364L15.9045 5.09544V17.0587H19.4149V1.11963H14.3713L9.71106 12.5492L5.02211 1.11963H0.00717119H0Z","fill":"#3216B5","key":1})]);
}

M2ProLogoCollapsedComponent.defaultProps = {"width":"36","height":"18","viewBox":"0 0 36 18","fill":"none"};

module.exports = M2ProLogoCollapsedComponent;

M2ProLogoCollapsedComponent.default = M2ProLogoCollapsedComponent;
